import React from 'react';
import { ValidationErrorsMessages } from '../FormValidation';
import { ValidationControlHelper } from './../../helpers/ValidationControlHelper';

export const CheckBoxControl = ({ field, handleChange, formDataEntry, errors } : ControlParameters) : JSX.Element => {

  const handleCheckboxChange = () => {
    handleChange({ target: { name: field["@column"], value: !(ValidationControlHelper.valueIsWhatBoolean(formDataEntry?.value)) } });
  };

  return (
    <div className={`form-group form-checkbox-group ${field.properties?.fieldcssclass ?? ''}`}>
      <div className="custom-control custom-checkbox">
        <input
          key={field["@guid"]}
          type="checkbox"
          className="custom-control-input"
          name={field["@column"]}
          required={!field["@allowempty"]}
          checked={ValidationControlHelper.valueIsWhatBoolean(formDataEntry?.value)}
          onChange={handleCheckboxChange}
        />
        <label className="custom-control-label" htmlFor={field["@column"]} onClick={handleCheckboxChange}>
          <span>{field.properties.fieldcaption}</span>
          {!field["@allowempty"] && (<span> *</span>)}
        </label>
      </div>
      <ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />
    </div>
  );
};